import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    buttonText: '',
    successMessage: '',
    items: [],
    rewards: [],
    isTerms: false,
    termsTitle: '',
    termsUrl: '',
    // Fan Ripping fields
    isNameCollect: false,
    isPhoneCollect: false,
    incentiveType: 'none',
    incentiveUrl: '',
    incentiveCode: '',
    incentiveTitle: '',
    incentiveImage: '',
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
};

export const dataCollectSlice = createSlice({
  name: 'dataCollect',
  initialState,
  reducers: {
    dataCollectStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = buttonDesign ?? {};
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        buttonText: blockContent.buttonText ?? '',
        successMessage: blockContent.successMessage ?? '',
        items: blockContent.items ?? [],
        rewards: blockContent.rewards ?? [],
        isTerms: blockContent.isTerms ?? false,
        termsTitle: blockContent.termsTitle ?? '',
        termsUrl: blockContent.termsUrl ?? '',
        // Fan Ripping fields
        isNameCollect: blockContent.isNameCollect ?? false,
        isPhoneCollect: blockContent.isPhoneCollect ?? false,
        incentiveType: blockContent.incentiveType ?? 'none',
        incentiveUrl: blockContent.incentiveUrl ?? '',
        incentiveCode: blockContent.incentiveCode ?? '',
        incentiveTitle: blockContent.incentiveTitle ?? '',
        incentiveImage: blockContent.incentiveImage ?? '',
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    dataCollectClear: () => initialState,

    dataCollectUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    dataCollectUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    dataCollectUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    dataCollectUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { dataCollectStore, dataCollectClear, dataCollectUpdateIsLoading, dataCollectUpdateIsActive, dataCollectUpdateBlockContent, dataCollectUpdateBlockDesign } =
  dataCollectSlice.actions;

export const selectDataCollectIsLoading = (state) => state.dataCollect.isLoading;

export const selectDataCollectId = (state) => state.dataCollect.id;
export const selectDataCollectUID = (state) => state.dataCollect.uid;
export const selectDataCollectSID = (state) => state.dataCollect.sid;

export const selectDataCollectBlockContent = (state) => state.dataCollect.blockContent;

export const selectDataCollectSortItems = createSelector([selectDataCollectBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectDataCollectBlockDesign = (state) => state.dataCollect.blockDesign;
export const selectDataCollectButtonDesign = (state) => state.dataCollect.buttonDesign;
export const selectDataCollectItemDesign = (state) => state.dataCollect.itemDesign;
export const selectDataCollectContainerDesign = (state) => state.dataCollect.containerDesign;

export default dataCollectSlice.reducer;
